const sourceOptions = [
  { label: 'Direct', value: 'direct' },
  { label: 'AI', value: 'ai' },
  { label: 'Search', value: 'search' },
  { label: 'Social media', value: 'social' },
  { label: 'Metasearch', value: 'meta' },
  { label: 'Other', value: 'other' },
];

export default sourceOptions;
